/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shows the points a driver needs this race for each bracket, accounting for what they already scored in the last 2 races. A negative number (e.g. ≥ −23) means the driver has already built up enough performance that even a poor race would likely keep them in that bracket.`)
};

const es_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`muestra los puntos que un piloto necesita en esta carrera para cada nivel, considerando lo que ya anotó en las últimas 2 carreras. Un número negativo (ej. ≥ −23) significa que el piloto ya ha acumulado suficiente rendimiento.`)
};

const de_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zeigt die Punkte, die ein Fahrer in diesem Rennen für jede Stufe benötigt, unter Berücksichtigung der letzten 2 Rennen. Eine negative Zahl (z.B. ≥ −23) bedeutet, dass der Fahrer bereits genug Leistung aufgebaut hat.`)
};

const nl_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toont de punten die een coureur deze race nodig heeft voor elk niveau, rekening houdend met de laatste 2 races. Een negatief getal (bijv. ≥ −23) betekent dat de coureur al genoeg prestaties heeft opgebouwd.`)
};

const fr_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`montre les points nécessaires cette course pour chaque niveau, en tenant compte des 2 dernières courses. Un nombre négatif (ex. ≥ −23) signifie que le pilote a déjà accumulé assez de performance.`)
};

const it_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mostra i punti necessari in questa gara per ogni fascia, tenendo conto delle ultime 2 gare. Un numero negativo (es. ≥ −23) significa che il pilota ha già accumulato abbastanza prestazioni.`)
};

const pt_br2_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mostra os pontos que um piloto precisa nesta corrida para cada faixa, levando em conta as últimas 2 corridas. Um número negativo (ex. ≥ −23) significa que o piloto já acumulou desempenho suficiente.`)
};

const pt_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mostra os pontos necessários nesta corrida para cada nível, tendo em conta as últimas 2 corridas. Um número negativo (ex. ≥ −23) significa que o piloto já acumulou desempenho suficiente.`)
};

const ja_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`は各ブラケットに必要な今レースのポイントを示します（直近2レースの実績を考慮）。負の数（例：≥ −23）は、すでに十分なパフォーマンスを積み上げていることを意味します。`)
};

const zh_f1_budget_prob_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示车手在本场比赛达到各档位所需的积分（已考虑最近2场的成绩）。负数（如 ≥ −23）表示车手已经积累了足够的表现。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_prob_p3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_prob_p3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_prob_p3", locale)
	if (locale === "en") return en_f1_budget_prob_p3(inputs)
	if (locale === "es") return es_f1_budget_prob_p3(inputs)
	if (locale === "de") return de_f1_budget_prob_p3(inputs)
	if (locale === "nl") return nl_f1_budget_prob_p3(inputs)
	if (locale === "fr") return fr_f1_budget_prob_p3(inputs)
	if (locale === "it") return it_f1_budget_prob_p3(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_prob_p3(inputs)
	if (locale === "pt") return pt_f1_budget_prob_p3(inputs)
	if (locale === "ja") return ja_f1_budget_prob_p3(inputs)
	return zh_f1_budget_prob_p3(inputs)
};